export type MonitorsMapControlOption = (typeof monitorsMapControlOptions)[number];

export const monitorsMapControlOptions = ['all', 'exceeding'] as const;

export const FALLBACK_NUMERIC_SCALE = 3;
